import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.values";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {};
  },
  computed: {
    // 当前用户票的数量
    ticketCount: function ticketCount() {
      return Object.values(this.hasTickets).filter(function (v) {
        return !!v;
      }).length;
    },
    // 判断是否有场次在直播中
    liveSession: function liveSession() {
      var _this = this;

      var list = this.setting.演出场次.filter(function (v) {
        return v.开始时间 < _this.now && _this.now < v.结束时间 && _this.hasTickets[v.pid];
      });
      return list.length > 0 ? list[0] : null;
    }
  }
};